import {CloseIcon, Dialog, Flex} from "@fluentui/react-northstar";
import languageObject from "../../../translations";
import * as React from "react";
import {useCallback, useEffect, useState} from "react";
import {ConfigureList} from "./parts/ConfigureList";
import {SelectFile} from "./parts/SelectFile";
import {CheckingFile} from "./parts/CheckingFile";

enum ImportStep {
    SelectFile = 0,
    CheckingFile = 1,
    ConfigureList = 2
}

type State = {
    file: ArrayBuffer | null,
    name: string,
    users: Array<string>,
    step: ImportStep,
}

type Props = {
    open: boolean,
    onClose: () => void,
}

const initialState: State = {
    file: null,
    name: "",
    users: [],
    step: ImportStep.SelectFile,
}

export const ImportDialog = (props: Props) => {
    const [state, setState] = useState<State>({...initialState});

    useEffect(() => {
        if (!props.open) setState({...initialState});
    }, [props.open]);

    const handleFileSelected = useCallback((file: ArrayBuffer) => {
        setState(prevState => ({...prevState, file, step: ImportStep.CheckingFile}));
    }, []);

    const handleFileChecked = useCallback((users: Array<string>) => {
        setState(prevState => ({...prevState, step: ImportStep.ConfigureList, users}));
    }, []);

    let content = null;

    switch (state.step) {
        case ImportStep.SelectFile:
            content = (
                <SelectFile
                    onFileSelected={handleFileSelected}
                />
            )
            break;
        case ImportStep.CheckingFile:
            content = (
                <CheckingFile
                    file={state.file}
                    onFileChecked={handleFileChecked}
                />
            )
            break;
        case ImportStep.ConfigureList:
            content = (
                <ConfigureList
                    users={state.users}
                    onSaved={props.onClose}
                />
            )
            break;
    }

    return (
        <Dialog
            open={props.open}
            content={
                <Flex fill column styles={{minHeight: "450px"}}>
                    {content}
                </Flex>
            }
            styles={{paddingBottom: "10px"}}
            header={languageObject.translate("ImportList")}
            headerAction={{
                icon: <CloseIcon outline/>,
                title: 'Close',
                onClick: props.onClose,
            }}
        />
    );
}